<template>
  <b-modal title="Detalhes do Laudo Técnico" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-form-group label-cols="1" label="Definição:" label-align="center">
            <b-form-textarea v-model="template.definicao" rows="6"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Itens do Equipamento</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.componentes" :fields="fields.item_componente"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="10">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="1" label-align="right">
            <b-form-input id="descricao" v-model="descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="addComponente()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="delComponente()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Normas de Referência</b-alert>
      <b-row class="mt-2">
        <b-col cols="12">
          <b-table bordered hover small :items="template.normas" :fields="fields.item_norma"> </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <b-form-group label="Item:" label-for="item" label-cols="2" label-align="right">
            <b-form-input id="item" v-model="norma.item" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="2" label-align="right">
            <b-form-input id="descricao" v-model="norma.descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="1" class="pl-3 m-0">
          <b-button variant="primary" @click="addNorma()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="pl-1 m-0">
          <b-button variant="warning" @click="delNorma()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import ReportFields from "@/tools/ReportFields";

export default {
  name: "ModalDeLaudoTecnicoDescricao",

  components: {},

  data() {
    return {
      show: false,
      template: new LaudoTecnico(),
      fields: new ReportFields(),
      descricao: "",
      norma: { item: "", descricao: "" },
    };
  },

  methods: {
    addComponente() {
      this.template.componentes.push({
        item: this.template.componentes.length + 1,
        descricao: this.descricao,
      });
    },

    delComponente() {
      if (this.template.componentes.length > 0) {
        this.template.componentes.pop();
      }
    },

    addNorma() {
      this.template.normas.push({ item: this.norma.item, descricao: this.norma.descricao });
    },

    delNorma() {
      if (this.template.normas.length > 0) {
        this.template.normas.pop();
      }
    },

    call(laudo) {
      this.show = !this.show;
      this.template = laudo;
    },
  },

  setup() {
    const store = useSgcqStore();

    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped></style>
